import React from "react";
import cx from "classnames";
import styles from "./QuoteTableSkeletonLoader.module.scss";
import QuoteTableSkeletonLoaderCell from "./QuoteTableSkeletonLoaderCell";

interface IQuoteTableSkeletonLoaderProps {
    className?: string;
}

const QuoteTableSkeletonLoader: React.FC<IQuoteTableSkeletonLoaderProps> = ({
    className
}) => {
    return (
        <div
            className={cx(styles["loader-container"], styles["basic-container"], {
                [className]: !!className
            })}>
            <QuoteTableSkeletonLoaderCell isHighlighted />
            <QuoteTableSkeletonLoaderCell />
            <QuoteTableSkeletonLoaderCell />
            <QuoteTableSkeletonLoaderCell />
            <QuoteTableSkeletonLoaderCell />
            <QuoteTableSkeletonLoaderCell />
        </div>
    );
};

export default React.memo(QuoteTableSkeletonLoader);
